// src/utils/auth-sync.js
import { Preferences } from "@capacitor/preferences";

/**
 * Ensure the web storages have the auth values that may already exist
 * in Capacitor Preferences (iOS/Android). No-op if a token already
 * exists in web storage. Returns the token (or null) for convenience.
 */
export async function ensureWebTokenHydrated() {
  try {
    // If a token is already present in web storage, nothing to do.
    const hasWebToken =
      typeof window !== "undefined" &&
      (localStorage.getItem("token") || sessionStorage.getItem("token"));
    if (hasWebToken) return hasWebToken;

    // Read from Capacitor Preferences (won’t throw on web; just returns empty)
    const [{ value: token } = {}, { value: tokenType } = {}, { value: userId } = {}] =
      await Promise.all([
        Preferences.get({ key: "auth_token" }),
        Preferences.get({ key: "token_type" }),
        Preferences.get({ key: "user_id" }),
      ]);

    if (typeof window !== "undefined") {
      if (token) {
        // Write through to BOTH storages for maximum compatibility with existing code
        try {
          localStorage.setItem("token", token);
          sessionStorage.setItem("token", token);
        } catch {}
      }
      if (tokenType) {
        try {
          localStorage.setItem("token_type", tokenType);
          sessionStorage.setItem("token_type", tokenType);
        } catch {}
      }
      if (userId) {
        try {
          localStorage.setItem("user_id", String(userId));
          sessionStorage.setItem("user_id", String(userId));
        } catch {}
      }
    }

    return token || null;
  } catch {
    // swallow — hydration is best-effort
    return null;
  }
}
